"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRune = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const isRune = (assetId) => assetId === caip_1.thorchainAssetId;
exports.isRune = isRune;
